import Work from './Work';
import withUserEvents from '../../containers/apollo/withUserEvents';

const workWithUserEvents = withUserEvents(Work);
workWithUserEvents.displayName = Work.displayName;
export default workWithUserEvents;
